import { AdditionalCostType } from "_interfaces/driverTripCalculator.interfaces";

export const mockAdditionalCostTypes: AdditionalCostType[] = [
  {
    value: "toll",
    label: "Toll fees",
  },
  {
    value: "parking",
    label: "Parking fees",
  },
  {
    value: "loading",
    label: "Loading/unloading fees",
  },
  {
    value: "other",
    label: "Other operational costs",
  },
];
